import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, EMPLOYER, JOBS } from "../../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${EMPLOYER}/${JOBS}`;

export const fetchJobList = async (params) => {
  try {
    // Handle both old format (just page number) and new format (object with filters)
    const { page = 1, status, is_published, ...otherParams } = typeof params === 'number'
      ? { page: params }
      : params;

    // Build query parameters
    const queryParams = new URLSearchParams();
    queryParams.append('page', page.toString());

    // Add status filter if provided
    if (status) {
      queryParams.append('status', status);
    }

    // Add is_published filter if provided
    if (is_published !== undefined) {
      queryParams.append('is_published', is_published.toString());
    }

    // Add any other parameters
    Object.keys(otherParams).forEach(key => {
      if (otherParams[key] !== undefined && otherParams[key] !== null) {
        queryParams.append(key, otherParams[key].toString());
      }
    });

    const url = `${API_BASE_URL}?${queryParams.toString()}`;

    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();
    return data;
  } catch (error) {
    // console.log("error", error);
    // throw error;
    return error;
  }
};